
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/intents/share",
      function () {
        return require("private-next-pages/intents/share.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/intents/share"])
      });
    }
  